// RTK Query root API. Domain endpoints are added in api/endpoints/* via
// baseApi.injectEndpoints, keeping this file free of concrete routes.

import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: axiosBaseQuery(),
  tagTypes: [
    'Company',
    'Invite',
    'CompanyInvite',
    'Auth',
    'Modules',
    'Roles',
    'Tags',
    'Structure',
    'Levels',
    'Projects',
    'Inspections',
    'People',
    'Groups',
    'CompanyField',
    'OptionSet',
    'TopicSet',
    'DataSetup',
    'DataSource',
    'DataSourceEntries',
    'Form',
    'FormChoices',
    'FormFolder',
    'Workflow',
    'Submission',
    'ActivityLogs',
    'Trash',
    'Attendance',
    'AttendanceSettings',
    'ApiKeys',
    'CompanySettings',
    'Notifications',
    'Profile',
  ],
  endpoints: () => ({}),
});
